import React from "react";
import { Apple, Play } from "lucide-react";

const STORES = {
  play: { Icon: Play, top: "Get it on", name: "Google Play" },
  apple: { Icon: Apple, top: "Download on the", name: "App Store" },
};

export const StoreBadge = ({ store, url, testid }) => {
  const { Icon, top, name } = STORES[store];
  const inner = (
    <>
      <Icon size={22} className={store === "play" ? "fill-current" : ""} />
      <span className="text-left leading-tight">
        <span className={`block text-[10px] uppercase tracking-wider ${url ? "opacity-70" : ""}`}>{url ? top : "Coming soon to"}</span>
        <span className="block text-[15px] font-semibold font-display">{name}</span>
      </span>
    </>
  );
  const cls = "inline-flex items-center gap-2.5 h-12 pl-3.5 pr-5 rounded-xl transition-[transform,background-color] duration-200";
  if (!url) {
    return <span className={`${cls} bg-white/80 text-slate-500 ring-1 ring-slate-300 cursor-default`} data-testid={testid} aria-disabled="true">{inner}</span>;
  }
  return (
    <a href={url} target="_blank" rel="noreferrer" data-testid={testid} className={`${cls} bg-slate-900 text-white hover:bg-slate-700 hover:-translate-y-0.5`}>
      {inner}
    </a>
  );
};

export default StoreBadge;
